// Where is this bundle running? The AI terminal ([[ai-terminal-localhost-constraint]]) talks to
// a model runner on the USER's own machine (Docker Model Runner, :12434). A public HTTPS page at
// app.griddapp.com cannot reach that (CORS + Private Network Access block it), so the terminal is
// only meaningful in two runtimes:
//
//   • a dev/localhost origin — the webpack dev server proxies `/__dmr` to localhost DMR;
//   • the packaged Electron desktop shell — its main process reaches localhost with no CORS.
//
// Everywhere else (the deployed website) the terminal is hidden and users are offered the desktop
// app instead. Keep this the single source of truth for that decision.

/** The Electron preload sets this on `window` so the page can detect the desktop shell. */
interface DesktopGlobals {
  __slidecraftDesktop?: boolean;
}

/** True in the Electron desktop shell — via the preload flag, or the Electron UA tag as fallback. */
export function isElectron(): boolean {
  if (typeof window === "undefined") return false;
  if ((window as unknown as DesktopGlobals).__slidecraftDesktop === true)
    return true;
  return (
    typeof navigator !== "undefined" &&
    /\belectron\b/i.test(navigator.userAgent)
  );
}

/** True for a loopback origin (dev server, or the app opened directly on localhost). */
export function isLocalhost(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "::1" ||
    host === "[::1]"
  );
}

/**
 * Whether the AI terminal may run here: the desktop shell, or a localhost origin. False on the
 * deployed website, where the browser cannot reach the user's local model.
 */
export function isAiTerminalAvailable(): boolean {
  return isElectron() || isLocalhost();
}
